module.exports = __webpack_public_path__ + "static/media/xing.08020d14.svg";